module.exports = __webpack_public_path__ + "static/media/ban.039344e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ban.svg
// module id = 1228
// module chunks = 0